import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export function Layout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-1 min-h-0 min-w-0 flex flex-col">
        <div className="w-full h-full flex flex-col min-h-0 min-w-0">
          <Outlet />
        </div>
      </main>
      <footer className="w-full bg-white border-t border-gray-200 py-6 px-6">
        <div className="flex items-center justify-center gap-8 max-sm:flex-col max-sm:gap-4">
          <a href="https://www.mincit.gov.co/" target="_blank" rel="noopener noreferrer">
            <img src="/min_industria_turismo.webp" alt="Ministerio de Industria y Turismo" className="h-10" />
          </a>
          <a href="https://fontur.com.co/" target="_blank" rel="noopener noreferrer">
            <img src="/fontur.webp" alt="Fontur" className="h-10" />
          </a>
          <a href="https://camaraarmenia.org.co/" target="_blank" rel="noopener noreferrer">
            <img src="/logo_camara.webp" alt="Cámara de Comercio" className="h-10" />
          </a>
          <a href="https://vivexia.co/" target="_blank" rel="noopener noreferrer">
            <img src="/logo.webp" alt="VivexIA logo" className="h-10" />
          </a>
        </div>
      </footer>
    </div>
  );
}
